<template>
<div class="cancer">
  <pt-sub-title title="检测项知识库详情"></pt-sub-title>
	<div v-for="(level1, index) in currentContents" :key="index">
		<p style="margin:0"><el-button type="text" @click="insert(index)">插入一级模块</el-button></p>
		<pt-form-item label="一级标题" :labelWidth="labelWidth" :required="true">
			<el-select v-model.trim="level1.header" placeholder="请选择">
				<el-option
					v-for="item in level1Options"
					:key="item.header"
					:label="item.header"
					:value="item.header">
				</el-option>
			</el-select>
			<el-button type="text" @click="cancelInsert(index)">删除一级模块</el-button>
		</pt-form-item>
		<pt-form-item label="一级说明" prop="description" :labelWidth="labelWidth">
			<el-input placeholder="请输入内容" v-model="level1.description" type="textarea" :autosize="{ minRows: 5}"></el-input>
		</pt-form-item>
    <pt-form-item label="富文本内容" :labelWidth="labelWidth">
      <div class="exampleBox">
        <el-input placeholder="请输入富文本内容" v-model="level1.richTextContent" type="textarea" :autosize="{ minRows: 8}"></el-input>
        <div class="example">
          <p>*富文本内容目前仅支持表格的录入，表格格式使用table标签录入</p>
          <p>表格示例：</p>
          <p v-html="exampleTable"></p>
          <el-button type="text" @click="insertTable(level1)">导入表格参数</el-button>
        </div>
      </div>

    </pt-form-item>
		<div v-for="(level2, index_sec) in level1.contents" :key="index_sec">
			<p style="margin:0"><el-button type="text" @click="insertLevel2(index,index_sec)">插入二级模块</el-button></p>
				<pt-form-item label="二级标题" :labelWidth="labelWidth">
					<!-- 图标select -->
					<el-select
						v-model.trim="level2.header"
						filterable
						default-first-option
						placeholder="请选择二级标题" @change="leve2Change(level1Options,level1.header,level2)">
						<el-option
							v-for="item in getNextLevelOptions(level1Options,level1.header)"
							:key="item.header"
							:label="item.header"
							:value="item.header">
						</el-option>
					</el-select>
					<el-button type="text" @click="cancelInsertLevel2(index,index_sec)">删除二级模块</el-button>
				</pt-form-item>
			<pt-form-item label="二级说明" :labelWidth="labelWidth">
				<el-input placeholder="请输入内容" v-model="level2.description" type="textarea" :autosize="{ minRows: 5}"></el-input>
			</pt-form-item>
      <pt-form-item label="富文本内容" :labelWidth="labelWidth">
        <div class="exampleBox">
          <el-input placeholder="请输入富文本内容" v-model="level2.richTextContent" type="textarea" :autosize="{ minRows: 8}"></el-input>
          <div class="example">
            <p>*富文本内容目前仅支持表格的录入，表格格式使用table标签录入</p>
            <p>表格示例：</p>
            <p v-html="exampleTable"></p>
            <el-button type="text" @click="insertTable(level2)">导入表格参数</el-button>
          </div>
        </div>
			</pt-form-item>
			<div v-for="(level3, index_third) in level2.contents" :key="index_third">
				<p style="margin:0"><el-button type="text" @click="insertLevel3(index,index_sec,index_third)">插入三级模块</el-button></p>
				<pt-form-item label="三级标题" :labelWidth="labelWidth">
          <el-input placeholder="请输入三级标题" v-model.trim="level3.header" ></el-input>
					<el-button type="text" @click="cancelInsertLevel3(index,index_sec,index_third)">删除三级模块</el-button>
				</pt-form-item>
				<pt-form-item label="三级说明" :labelWidth="labelWidth">
					<el-input placeholder="请输入内容" v-model="level3.description" type="textarea" :autosize="{ minRows: 5}"></el-input>
				</pt-form-item>
			</div>
			<p :style="{paddingLeft:'110px'}">
				<el-button type="primary" class="addBtn" @click="addLevel3(index,index_sec)">添加三级标题</el-button>
			</p>
		</div>
		<pt-form-item label="" :labelWidth="labelWidth">
			<el-button  v-if="showNextLevelBtn(level1Options,level1.header)" type="primary" class="addBtn" @click="addLevel2(index)">添加二级标题</el-button>
			<el-button type="primary" v-if="index==currentContents.length-1" class="addBtn" @click="addLevel1(index)">添加一级标题</el-button>
		</pt-form-item>
	</div>
</div>
</template>
<script>
export default {
  name: 'cancer',
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    labelWidth: {
      type: String,
      default: '100px'
    },
    // 根据类型筛选出对应的知识结构
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentContents: this.value.length ? this.value : [{
        header: '',
        description: '',
        contents: [],
        richTextContent: ''
      }
      ],
      level1Options: [],
      exampleTable: '<table>\n<tr><th>标题1</th><th>标题2</th><th>标题3</th></tr>\n<tr><td>内容A</td><td>内容B</td><td>内容C</td></tr>\n<tr><td>内容D</td><td>内容E</td><td>内容F</td></tr>\n</table>'
    }
  },
  watch: {
    currentContents: {
      handler: function (val, old) {
        this.$emit('input', val)
      },
      deep: true
    },
    type (val) {
      this.getCorpusStructure(val)
      console.log(val)
    }
  },
  methods: {
    escapeHTMLString (str) {
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      return str
    },
    insertTable (data) {
      data.richTextContent = this.exampleTable
    },
    showNextLevelBtn (preLevelOptions, preHeader) {
      let nextOptions = this.getNextLevelOptions(preLevelOptions, preHeader)
      if (typeof (nextOptions) !== 'undefined' && nextOptions.length) {
        return true
      }
      return false
    },
    leve2Change (level1Options, level1Header, level2) {
      let options = this.getNextLevelOptions(level1Options, level1Header)
      console.log(options)
      let targetOptions = options.filter(e => e.header === level2.header)[0]
      level2.hasIcon = targetOptions.hasIcon
      level2.headerImage = targetOptions.headerImage
    },
    // 插入一条一级模块
    insert (index) {
      this.currentContents.splice(index, 0, { header: '', description: '', contents: [], richTextContent: '' })
      console.log(this.currentContents)
    },
    cancelInsert (index) {
      if (index === 0 && this.currentContents.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.currentContents.splice(index, 1)
      })
    },
    insertLevel2 (index, indexSec) {
      var level1 = this.currentContents[index]
      level1.contents.splice(indexSec, 0, { header: '', description: '', contents: [], richTextContent: '' })
    },
    cancelInsertLevel2 (index, indexSec) {
      var level1 = this.currentContents[index]
      this.$confirm('确定要删除该模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        level1.contents.splice(indexSec, 1)
      })
    },
    insertLevel3 (index, indexSec, indexThird) {
      var level2 = this.currentContents[index].contents[indexSec]
      level2.contents.splice(indexThird, 0, { header: '', description: '' })
    },
    cancelInsertLevel3 (index, indexSec, indexThird) {
      var level2 = this.currentContents[index].contents[indexSec]
      this.$confirm('确定要删除该模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        level2.contents.splice(indexThird, 1)
      })
    },
    // 添加一级标题
    addLevel1 (index) {
      if (this.currentContents[this.currentContents.length - 1].header === '') {
        this.$message.error('请填写一级标题')
        return
      }
      var level2 = this.currentContents[index].contents
      // 判断最后一个二级标题是否填写
      if (level2.length) {
        if (level2[level2.length - 1].header === '') {
          this.$message.error('请填写二级标题')
          return
        }
        // 判断最近的一个三级标题是否为空
        var level3 = level2[level2.length - 1].contents
        if (level3.length && level3[level3.length - 1].header === '') {
          this.$message.error('请填写三级标题')
          return
        }
      }
      this.currentContents.push({ header: '', description: '', contents: [], richTextContent: '' })
    },
    // 取消添加一级标题
    cancelAddLevel1 () {
      this.currentContents.splice(this.currentContents.length - 1, 1)
    },
    // 添加二级标题
    addLevel2 (index) {
      var level1 = this.currentContents[index]
      if (level1.header === '') {
        this.$message.error('请填写一级标题')
        return
      }
      if (level1.contents.length) {
        // 判断最近的一个二级标题是否为空
        if (level1.contents[level1.contents.length - 1].header === '') {
          this.$message.error('请填写二级标题')
          return
        }
        // 判断最近的一个三级标题是否为空
        var level3 = level1.contents[level1.contents.length - 1].contents
        if (level3.length && level3[level3.length - 1].header === '') {
          this.$message.error('请填写三级标题')
          return
        }
      }
      level1.contents.push({ header: '', description: '', contents: [], richTextContent: '' })
    },
    // 取消添加二级标题
    cancelAddLevel2 (index) {
      var level2 = this.currentContents[index].contents
      level2.splice(level2.length - 1, 1)
    },
    // 添加三级标题
    addLevel3 (index, indexSec) {
      var level2 = this.currentContents[index].contents[indexSec]
      if (level2.header === '') {
        this.$message.error('请填写二级标题')
      } else {
        // 判断最近的一个三级标题是否为空
        if (level2.contents[level2.contents.length - 1] && level2.contents[level2.contents.length - 1].header === '') {
          this.$message.error('请填写三级标题')
          return
        }
        level2.contents.push({ header: '', description: '' })
      }
    },
    // 取消添加三级标题
    cancelAddLevel3 (index, indexSec) {
      var level3 = this.currentContents[index].contents[indexSec].contents
      level3.splice(level3.length - 1, 1)
    },
    getCorpusStructure (type) {
      let data = {
        type: type,
        page: 0,
        size: 99999
      }
      this.$store.dispatch('getCorpusStructureListByType', data).then(res => {
        this.level1Options = res.data.map(item => {
          return item.structure
        })
        // console.log('this.level1Options', this.level1Options)
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
      })
    },
    getNextLevelOptions (preLevelOptions, preHeader) {
      return preLevelOptions.filter(item => item.header === preHeader).map(e => e.contents)[0]
    }
  },
  created () {
    if (this.value.length) {
      this.currentContents = this.value
    }
    if (this.type) {
      this.getCorpusStructure(this.type)
    }
  }
}

</script>
<style lang="less">
.cancer{
  .example{
    width:700px;
    color:#bdbdbd;
    line-height: 22px;
    font-size: 13px;
    margin-left: 20px;
    line-height: 14px;
  }
  .exampleBox{
    display: flex;
  }
}

</style>
